import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

class QuizinatorNum extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ans: null,
            cont: false
        };

        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        let quiz = this.props.quiz,
            question = this.props.quiz.questions[this.props.currentQuestionIndex],
            htmlQuestion = function () {
                return { __html: question.question };
            };

        return (
            <section className={'quizSection' + (this.props.buttonsDisabled ? ' transitionOut' : '')}>
                <div className="questionNumber">Question {this.props.currentQuestionIndex + 1} / {quiz.questions.length}</div>
                <div className="question">
                    <div dangerouslySetInnerHTML={htmlQuestion()} />
                </div>
                <div className="answers">
                    <Form.Control type='number' placeholder={this.props.placeholder || ''}
                        key={`txt_${question.id || ''}`}
                        onChange={(e) => {
                            let ans = e.target.value;
                            this.setState({ans: ans, cont: true});
                        }}>
                    </Form.Control>
                    <br/>
                    <button onClick={this.handleClick.bind(this)} className={(!this.state.cont)?'disabled':''} disabled={!this.state.cont}>Next</button>
                </div>
            </section>
        );
    }

    handleClick(event) {
        let { ans } = this.state;
        let answer = { value: ans },
            target = event.currentTarget;

        this.props.submitAnswer(answer);

        target.classList.add('clicked');

        let that = this;
        window.setTimeout(function () {
            target.classList.remove('clicked', 'correct', 'incorrect');
            that.setState({cont: false, ans: null});
        }, this.props.transitionDelay);
    }
}

export default QuizinatorNum;